import jsPDF from 'jspdf';

const createItemLabel = (
  { l1Content = '', l1FontWeight = 'bold' },
  { l2Content = '', l2FontWeight = 'bold' },
  { l3Content = '', l3FontWeight = 'bold' },
  { l4Content = '', l4FontWeight = 'normal' },
  { l5Content = '', l5FontWeight = 'normal' },
) => {
  const doc = new jsPDF({
    orientation: 'portrait',
    unit: 'mm',
    format: [57, 32], // [167, 91]
  });

  doc.setFontSize(11);
  const pT = 7;

  doc.setFont('Helvetica', l1FontWeight);

  if (l1Content !== '') {
    doc.text(l1Content, pT, 55, { angle: 90 });
  }
  doc.setFont('Helvetica', l2FontWeight);
  if (l2Content) {
    doc.text(l2Content, pT + 5, 55, { angle: 90 });
  }
  doc.setFont('Helvetica', l3FontWeight);
  doc.text(l3Content.substr(0, 28), pT + 10, 55, { angle: 90 });

  doc.setFont('Helvetica', l4FontWeight);
  doc.setFontSize(9);
  doc.text(l4Content.substr(0, 28), pT + 15, 55, { angle: 90 });
  doc.setFont('Helvetica', l5FontWeight);
  doc.text(l5Content, pT + 20, 55, { angle: 90 });

  const pdf = doc.output('blob');
  return pdf;
};

export default createItemLabel;
